import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Star, Quote } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then(r => setItems(r.data)); }, []);
  return (
    <div data-testid="testimonials-page">
      <section className="lumina-bg-soft py-20">
        <div className="lumina-container">
          <div className="lumina-label mb-3">Testimoni</div>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tighter text-[#1A1728] mb-6 max-w-3xl">Cerita perubahan dari mereka.</h1>
        </div>
      </section>
      <section className="lumina-container py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map(t => (
            <div key={t.id} className="lumina-card p-7" data-testid={`testimonial-${t.id}`}>
              <Quote className="w-8 h-8 text-[#9D84D2] mb-4" />
              <p className="text-[#1A1728] leading-relaxed mb-6">"{t.content}"</p>
              <div className="flex mb-3">{[...Array(t.rating)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[#FFB74D] text-[#FFB74D]" />)}</div>
              <div className="flex items-center gap-3 pt-4 border-t border-[#E2DFED]">
                {t.image && <img src={t.image} alt={t.name} className="w-10 h-10 rounded-full object-cover" />}
                <div>
                  <div className="font-medium text-[#1A1728]">{t.name}</div>
                  <div className="text-xs text-[#5C5870]">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
